<div class="container-fluid fluid2 print" style="margin:1rem 0">
    <div class="div_loading">
        <div class="my-container" [hidden]="!loading">
            <mat-progress-bar mode="indeterminate" class="detaile"></mat-progress-bar>
        </div>
    </div>

    <section class="container-fluid invoice">
        <div class="row containerInier">
            <div class="row" style="padding:15px">
                <!-- ************************************************************************************************************  -->
                <div class="row row2" *ngIf="list_material.length > 0">
                    <div class="row row1">
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-sm-3 header-title1">
                            نام دسته کلی
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-sm-6 row1_div2">
                            <div class="row">
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                    <div class="row">
                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12"
                                            style="float: left;border-bottom: solid 1px #000;">
                                            <div class="row">
                                                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-sm-4 header-title1"
                                                    style="float: left">
                                                    دسته میانی
                                                </div>
                                                <div
                                                    class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-sm-8 div_list_material">
                                                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 div_material">
                                                        <div
                                                            class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-sm-6 header-title1">
                                                            نام دسته کالا
                                                        </div>
                                                        <div
                                                            class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-sm-6 div_logo header-title1">
                                                            عکس
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div><!-- col-xl-9 col-lg-9 col-md-9 col-sm-9 col-sm-9 -->
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-sm-3  header-title1">
                            عکس تمام شده
                        </div>
                    </div>

                    <div class="row row1 cate_title " *ngFor="let x of list_cate">
                        <div class="row">
                            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-sm-3 cate_title_div4 title1 ">
                                {{ x.wharehouse_material_cate_title }}
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-sm-6 row1_div2 cate_title_div4">
                                <div class="row">
                                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12" *ngFor="let xx of list_cate2"
                                        [ngClass]="{cate_title_div10:xx.wharehouse_material_cate2_cate == x.wharehouse_material_cate_id,none:xx.wharehouse_material_cate2_cate != x.wharehouse_material_cate_id}">
                                        <div class="row">
                                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 cate_title_div4"
                                                style="float: left;border-bottom: solid 1px #000;"
                                                *ngIf="xx.wharehouse_material_cate2_cate == x.wharehouse_material_cate_id">
                                                <div class="row">
                                                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-sm-4 cate_title_div4 title1"
                                                        style="float: left">
                                                        {{ xx.wharehouse_material_cate2_title }}
                                                    </div>
                                                    <div
                                                        class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-sm-8 div_list_material">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 div_material"
                                                            *ngFor="let material of list_material;let material_i = index"
                                                            [ngClass]="{cate_title_div10:material.wharehouse_order_cate2 == xx.wharehouse_material_cate2_id,none:material.wharehouse_order_cate2 != xx.wharehouse_material_cate2_id}">
                                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-sm-6 cate_title_div4 title1"
                                                                *ngIf="material.wharehouse_order_cate2 == xx.wharehouse_material_cate2_id">
                                                                {{ material.wharehouse_material_title }} {{ material_i +
                                                                1 }}
                                                            </div>
                                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-sm-6 cate_title_div4 div_logo"
                                                                *ngIf="material.wharehouse_order_cate2 == xx.wharehouse_material_cate2_id">
                                                                <img class="logo" [src]="material.logo"
                                                                    *ngIf="material.logo">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div><!-- col-xl-4 col-lg-4 col-md-4 col-sm-4 col-sm-4 cate_title_div4 -->
                                        </div><!-- row-->
                                    </div><!-- class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-sm-12 -->

                                </div>
                            </div><!-- col-xl-3 col-lg-3 col-md-3 col-sm-3 col-sm-3 -->
                            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-sm-3 cate_title_div4 title1"
                                style="padding-top:0.2rem">
                                <span *ngFor="let logo of list_logo2" [hidden]="!logo.logo2">
                                    <div style="margin-bottom: 0.2rem" *ngIf="logo.logo2">
                                        <img class="logo" [src]="logo.logo2"
                                            *ngIf="x.wharehouse_material_cate2_cate == logo.cate">
                                    </div>
                                </span>

                            </div>
                        </div><!-- row -->
                    </div>
                </div>
                <!-- ************************************************************************************************************ -->
            </div>
        </div>
    </section>
    <footer class="container-fluid footer">
        <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <span class="noprint" style="float: left;">
                    <a href="javascript:window.print()" class="btn btn-default print-button"><i
                            class="icon-printer"></i> پرینت</a>
                </span>
            </div>
        </div>
    </footer>
</div>